import { MyTicketsFilter, MyTicketsHeader, MyTicketsTable } from "./components";

import { useTickets } from "@hooks/tickets/e-tickets/useTickets";
import { useTicketDropdown } from "@hooks/tickets/ticket-settings/useTicketDropdown";

import { useUnitsForAllTickets } from "@hooks/tickets/e-tickets/useUnitsForAllTickets";

import { URLS } from "@constants/urls";
import { useUnitWiseEmployee } from "@hooks/tickets/e-tickets/useUnitWiseEmployee";

const {
  MY_TICKET,
  TICKET_CATEGORIES,
  TICKET_TYPES,
  TICKET_STATUS,
  TICKET_PRIORITIES,
} = URLS;

const MyTickets = () => {
  const ticketsData = useTickets(MY_TICKET);
  const ticketTypes = useTicketDropdown(TICKET_TYPES);
  const categories = useTicketDropdown(TICKET_CATEGORIES);
  const priorities = useTicketDropdown(TICKET_PRIORITIES);
  const statuses = useTicketDropdown(TICKET_STATUS);
  const ticketDropdown = { ticketTypes, statuses, categories, priorities };

  // const { data: wings } = useBaseData(BASE_DATA.WINGS);
  // const { data: commonInfoResponse } = useEmployeeServiceData({
  //   dataType: EMPLOYEE_SERVICE_DATA.COMMON_INFO,
  //   unitIds: "30,31,32,33", //Information and Technology Cell
  // });

  const { units } = useUnitsForAllTickets();

  // const commonInfo = commonInfoResponse?.commonInfo || [];

  const { employees, handleQuery: handleEmployeeQuery } = useUnitWiseEmployee();

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <MyTicketsHeader />
      <MyTicketsFilter
        ticketDropdown={ticketDropdown}
        wings={units}
        commonInfo={employees}
        handleQuery={ticketsData?.handleQuery}
        handleEmployeeQuery={handleEmployeeQuery}
      />
      <MyTicketsTable data={ticketsData} ticketDropdown={ticketDropdown} />
    </div>
  );
};

export default MyTickets;
